const urlSearch = new URLSearchParams(window.location.search);

export default urlSearch;
